import React, { useState } from 'react'
import LinkButton from '../../components/LinkButton'
import getVectorImage from '../../utils/getVectorImage'
import styles from './SideTable.module.scss'
import toTitleCase from '../../utils/toTitleCase'
import { useGeoState } from '../../components/GeoProvider'
import { useHistory } from 'react-router-dom'
const Databind = ({ state, chartRef }) => {
  const { regionSelected,displayDate } = useGeoState()
  const history = useHistory()

  const handleMouseOver = (element) => {
       if (chartRef.current != null) {
      const chart = chartRef.current.chart
      var indexSeries =
        regionSelected === 'metro' ? 1 : regionSelected === 'zip3' ? 2 : 0
      if (chart !== undefined && chart !== null) {
        
        if(indexSeries == 1){
            const geoParentValue = element.attributes['geo_parent'].textContent;
            const geoIdValue = element.attributes['geo_id'].textContent;
  
            const point = chart.series[indexSeries].points.find(function(point) {
            const geoIdMatch = point.geo_id === geoIdValue;
  
            if (!geoIdMatch) return false;
  
            if (point.geo_parent.includes(',')) {
                const geoArray = point.geo_parent.split(',');
                if (geoArray.includes(geoParentValue)) {
                  return true;
               }
            } else {
                if (point.geo_parent === geoParentValue) {
                  return true;
            }
        }
          return false;
      });
      
      if (point) {
      const originalGeoParent = point.geo_parent; 
      point.update({ geo_parent: geoParentValue }, false); // update without redraw
      chart.tooltip.refresh(point);
      point.update({ geo_parent: originalGeoParent }, false); // restore original

        // const pointAfterUpdate = Object.assign({}, point);
        // pointAfterUpdate.geo_parent = geoParentValue;
        // pointAfterUpdate && chart.tooltip.refresh(pointAfterUpdate); 
      }
        }
        else{
          const point = chart.series[indexSeries].points.find(
            (point) => point.geo_id === element.attributes['geo_id'].textContent
            //element.getAttribute('title')
          )
          point && chart.tooltip.refresh(point)
        } 
      }
    }
  }

  const handleMouseOut = () => {
    const chart = chartRef.current.chart
    if (chart && chart.tooltip) {
      chart.tooltip.destroy()
    }
  }
  return (
    <div style={{ display: 'flex' }} className={styles.Layout}>
      <div
        style={{
          width: '80%',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
        }}
        title={state.geo_name}
      >
        <LinkButton
          onMouseOver={(e) =>regionSelected.toLowerCase()==='zip3'?'': handleMouseOver(e.target)}
          onMouseOut={() => regionSelected.toLowerCase()==='zip3'?'':handleMouseOut()}
          className={styles.btn}
          onClick={() => {
            {
              regionSelected === 'metro'
                ? history.push(
                    `/forecasts/utimsadashboard/${state.geo_parent.toLowerCase()}/msa/${state.geo_id.toLowerCase()}`
                  )
                : history.push(`/forecasts/utistatedashboard/state/${state.geo_id.toLowerCase()}`)
            }
          }}
          data-title={state.geo_name}
          title={state.geo_name}
          geo_id={state.geo_id}
          geo_parent={state.geo_parent}
        >
          {state.geo_name}
        </LinkButton>
      </div>
      <div className={styles.columnRate}>{state.data_value}</div>
      {/* <div className={styles.columnDays}>
        <span> {getVectorImage(state.istrue)} </span>
        <span
          className={
            state.istrue ? styles.percentageRed : styles.percentageGreen
          }
        >
          {' '}
          {state.percentage}%
        </span>
      </div> */}
    </div>
  )
}

const SideTable = ({ stateData, chartRef }) => {
  let mapStatesData = null
  let statesDataForDisplayDate=null
  const { displayDate } = useGeoState()
    statesDataForDisplayDate = Object.entries(stateData[displayDate])
      mapStatesData = statesDataForDisplayDate.map((state) => {    
      return {
        value: state[1]['forecast_level'],
        state: state[0],
        borderColor:  '#e0d4d4ff',  
        ...state[1],    
      }
    }) 
  const { regionSelected } = useGeoState()
  const stateDataForDisplayDate = Object.entries(mapStatesData)
  const mappedStateData = stateDataForDisplayDate.map((state) => {
    const stateName = state[1].geo_name
    return { ...state[1], name: stateName, identifier: stateName }
  })
  let filteredStateData = mappedStateData
   const [getFilter, setfilter] = useState('down')
  const sortBy = (action) => {
    if (action === 'up') {
      setfilter('down')
      mapStatesData.sort((a, b) => b.geo_name - a.geo_name)
    } else if (action === 'down') {
      setfilter('up')
      mapStatesData.sort((a, b) => a.geo_name - b.geo_name)
    }
  }
  return (
    <div className={styles.base}>
      <div className={styles.header}>
        <div
          style={{
            width: '100%',
            justifyContent: 'flex-start',
            marginTop: '16px',
          }}
        >
          <div style={{ display: 'flex' }}>
            <div
              style={{
                display: 'inline-flex',
                width: '70%',
              }}
            >
              <span>
                <h5
                  style={{
                    fontFamily: 'Optum Sans',
                    fontSize: '21px',
                    fontWeight: '600',
                    color: '#002677',
                  }}
                >
                  {regionSelected === 'metro'
                    ? toTitleCase(regionSelected) + ' Area Count'
                    : toTitleCase(regionSelected) + ' Count'}
                </h5>
              </span>
            </div>
          </div>
          <div
            style={{
              fontSize: '12px',
              display: 'flex',
              lineHeight: '18px',
              padding: '1rem 0rem 0',
            }}
          >
            <span> {getVectorImage('Info', '16px', '16px')}</span> &nbsp;&nbsp;
            <div
              style={{ '&::WebkitScrollbar': { width: 0, height: 0 } }}
              className={styles.sideTableHeader}
            >
              {' '}
              This table is sorted by count of UTI cases.
            </div>
          </div>
        </div>
        <div
          style={{
            padding: '0rem 0rem',
            paddingBottom: '0.5rem',
            paddingTop: '0.5rem',
            borderTop: '1px solid #CBCCCD',
            borderBottom: '2px solid #002677',
            marginTop: '5px',
          }}
        >
          <div style={{ display: 'inline-flex', width: '70%' }}>
            <h4>{toTitleCase(regionSelected)}</h4>
          </div>
          <div
            style={{
              display: 'inline-flex',
              width: '30%',
              justifyContent: 'flex-middle',
              cursor: 'pointer',
            }}
          >
            <h4 onClick={() => sortBy(getFilter)}>
              Count{' '}
              {/* <span style={{ marginLeft: '4px' }}>
                {getVectorImage(getFilter)}
              </span> */}
            </h4>
          </div>
          {/* <div
            style={{
              display: 'inline-flex',
              width: '26%',
              justifyContent: 'flex-middle',
            }}
          >
            <h4>Change</h4>
          </div> */}
        </div>
      </div>

      <div className={styles.scroll}>
        {filteredStateData.map((state) => {
          return (
            <Databind state={state} key={state.statename} chartRef={chartRef} />
          )
        })}
      </div>
    </div>
  )
}

export default SideTable
